import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { motion } from "framer-motion";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-hussar-bg flex items-center justify-center px-6">
      <div className="grain-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-10">
          <div className="w-12 h-12 border border-hussar-gold/50 flex items-center justify-center mx-auto mb-6">
            <span className="font-serif text-hussar-gold text-2xl">H</span>
          </div>
          <div className="metadata-label mb-2">Hussar Treasury</div>
          <h1 className="font-serif text-2xl text-hussar-ink">Publishing Console</h1>
          <p className="text-hussar-muted text-xs mt-3 font-mono uppercase tracking-[0.2em]">Owner access only</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="border border-white/5 bg-hussar-card p-8 space-y-5">
          <div>
            <label className="metadata-label !text-[10px] block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="field-input" />
          </div>
          <div>
            <label className="metadata-label !text-[10px] block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="field-input" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-red-400 text-xs font-mono">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="btn-gold w-full disabled:opacity-50">
            {loading ? "Verifying…" : "Enter Console"}
          </button>
        </form>
        <div className="text-center mt-8">
          <Link to="/" data-testid="admin-back-to-site" className="text-hussar-muted text-xs font-mono uppercase tracking-[0.2em] hover:text-hussar-gold transition-colors">
            ← Back to public site
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
